var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedLumensIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#FFA700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 15.083h1.417M12.083 8v3.542V8zm5.009 2.075l-2.48 2.479 2.48-2.48zm2.075 5.008h-3.542 3.542zM5 15.083h3.542H5zm2.075-5.008l2.479 2.479-2.48-2.48z",
    stroke: "#fff",
    strokeWidth: 1.417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgLedLumensIcon;